const APP_URL = process.env.REACT_APP_BASE_URL;
const REFRESH_KEY = process.env.REACT_APP_REFRESH_KEY;
const SESSION_KEY = process.env.REACT_APP_SESSION_KEY;
const ID_KEY = process.env.REACT_APP_ID_KEY;
const USER_KEY = "USER_DETAILS";
const PASS_CODE_KEY = "PASS_CODE";
const TINGOG_URL = process.env.REACT_APP_TINGOG_URL;
const TINGOG_API_KEY = process.env.REACT_APP_TINGOG_API_KEY;
const S3_BUCKET = process.env.REACT_APP_S3_BUCKET;
const OMEGADB_URL = process.env.REACT_APP_OMEGADB_URL;
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || "";
const SENTRY_ENV = process.env.REACT_APP_SENTRY_ENV || "development";

const getAccessToken = () => {
  return localStorage.getItem(SESSION_KEY);
};

const getRefreshToken = () => {
  return localStorage.getItem(REFRESH_KEY);
};

const getIdToken = () => {
  return localStorage.getItem(ID_KEY);
};

const setAccessToken = (token, remove = false) => {
  if (token) {
    localStorage.setItem(SESSION_KEY, token);
  }

  if (remove) {
    localStorage.removeItem(SESSION_KEY);
  }
};

const setIdToken = (token, remove = false) => {
  if (token) {
    localStorage.setItem(ID_KEY, token);
  }

  if (remove) {
    localStorage.removeItem(ID_KEY);
  }
};

const setRefreshToken = (token, remove = false) => {
  if (token) {
    localStorage.setItem(REFRESH_KEY, token);
  }

  if (remove) {
    localStorage.removeItem(REFRESH_KEY);
  }
};

const setUserDetails = (data, remove = false) => {
  if (data) {
    localStorage.setItem(USER_KEY, JSON.stringify(data));
  }

  if (remove) {
    localStorage.removeItem(USER_KEY);
  }
};

const setUserPermissions = (data, remove = false) => {
  if (data) {
    localStorage.setItem("USER_PERMISSIONS", JSON.stringify(data));
  }

  if (remove) {
    localStorage.removeItem("USER_PERMISSIONS");
  }
};

const getUserDetails = () => {
  return JSON.parse(localStorage.getItem(USER_KEY) || null);
};

const getUserPermissions = () => {
  return JSON.parse(localStorage.getItem("USER_PERMISSIONS") || null);
};

const getPassCode = () => {
  return localStorage.getItem(PASS_CODE_KEY);
};

const setPassCode = (passCode, remove = false) => {
  if (passCode) {
    localStorage.setItem(PASS_CODE_KEY, passCode);
  }

  if (remove) {
    localStorage.removeItem(PASS_CODE_KEY);
  }
};

export {
  APP_URL,
  REFRESH_KEY,
  SESSION_KEY,
  ID_KEY,
  PASS_CODE_KEY,
  TINGOG_URL,
  TINGOG_API_KEY,
  S3_BUCKET,
  OMEGADB_URL,
  SENTRY_DSN,
  SENTRY_ENV,
  getAccessToken,
  setAccessToken,
  setRefreshToken,
  getRefreshToken,
  setUserDetails,
  getUserDetails,
  setIdToken,
  getIdToken,
  setUserPermissions,
  getUserPermissions,
  getPassCode,
  setPassCode,
};
